import cookie from 'cookie';
import { ListType } from './apis/dumpert';
import { settings } from './settings';

const isDocument = () => (typeof document === 'object');

const cookieDuration = {
  three_months: 60 * 60 * 24 * 90,
  year: 60 * 60 * 24 * 365,
};

const cookiePathMap = [
  { pathValue: 'filmpjes', cookieValue: '/video' },
  { pathValue: 'plaatjes', cookieValue: '/foto' },
];

export const pathToCookie = pathValue => (cookiePathMap.find(x => x.pathValue === pathValue) || {}).cookieValue;
export const cookieToPath = cookieValue => (cookiePathMap.find(x => x.cookieValue === cookieValue) || {}).pathValue;

export const documentGetCookie = name => isDocument() ? cookie.parse(document.cookie)[name] : null;

export const documentSetCookie = (name, value, path = '/', expires = 'year' ) => isDocument() ?
  document.cookie = cookie.serialize(name, value, { maxAge: cookieDuration[expires], path }) : '';

export const stringGetCookie = (name, cookieStr) => cookieStr ? cookie.parse(cookieStr)[name] : null;

export const getTypeOfListFromCookie = (pageType, staticContext) =>
  (staticContext ? stringGetCookie(pageType, staticContext.request.headers.cookie) :  documentGetCookie(pageType))
    || ListType.latest;

export const setHashedIdCookie = string => document.cookie.indexOf('dataAttribute') === -1 ?   
  fetch(`${settings.API_HOST}/mobile_api/json/gethashedid/${string}/`)
    .then(response => response.json())
    .then(data => documentSetCookie(
      'dataAttribute', data.user.hashed_id.hashedID.substring(0, 40), '/', 'three_months',
    )) 
  : null;